var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-dialog',{attrs:{"title":_vm.gameName || _vm.dice,"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.lines),function(line,i){return _c('div',{key:i},[_vm._v(_vm._s(line))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }